<div [formGroup]="formGroup">
  <div class="row mb-3">
    <div class="col">
      <label for="country" class="form-label">País</label>
      <select
        class="form-select"
        id="country"
        formControlName="country"
        [class.is-invalid]="formGroup.get('country')?.invalid && formGroup.get('country')?.touched">
        @for (country of countriesList; track country.acronym) {
          <option [value]="country.acronym">{{ country.name }}</option>
        }
      </select>
      @if (formGroup.get("country")?.invalid && formGroup.get("country")?.touched) {
        <div class="invalid-feedback">O campo país é obrigatório.</div>
      }
    </div>
  </div>

  <div class="row mb-3">
    <div class="col">
      <label for="postal_code" class="form-label">{{ isBrazilianCustomer ? "CEP" : "Código postal" }}</label>

      <div class="position-relative">
        <input
          type="text"
          class="form-control pe-5"
          id="postal_code"
          formControlName="postal_code"
          [placeholder]="isBrazilianCustomer ? '00000-000' : 'Código postal'"
          [mask]="isBrazilianCustomer ? '00000-000' : null"
          [readonly]="isLoadingCep"
          [class.loading-field]="isLoadingCep"
          [class.is-invalid]="formGroup.get('postal_code')?.invalid && formGroup.get('postal_code')?.touched" />

        @if (isLoadingCep) {
          <div class="position-absolute top-50 end-0 translate-middle-y pe-2 input-spinner">
            <div class="spinner-border spinner-border-sm text-secondary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
        }
      </div>

      @if (formGroup.get("postal_code")?.invalid && formGroup.get("postal_code")?.touched) {
        <div class="invalid-feedback">
          {{ isBrazilianCustomer ? "O campo CEP é obrigatório." : "O campo código postal é obrigatório." }}
        </div>
      }
    </div>
  </div>
  <div class="row mb-3">
    <div class="col">
      <label for="state" class="form-label">Estado</label>

      @if (isBrazilianCustomer) {
        @if (isLoadingCep) {
          <input
            type="string"
            id="state"
            formControlName="state"
            class="form-control"
            placeholder="Informe as siglas do Estado"
            [readonly]="isLoadingCep"
            [class.loading-field]="isLoadingCep"
            [class.is-invalid]="formGroup.get('state')?.invalid && formGroup.get('state')?.touched" />
        } @else {
          <select
            class="form-select"
            id="state"
            formControlName="state"
            [class.is-invalid]="formGroup.get('state')?.invalid && formGroup.get('state')?.touched">
            <option value="" disabled>Selecione um estado</option>
            @for (state of statesOptions; track state.code) {
              <option [value]="stateOptionValue(state)">{{ state.name }}</option>
            }
          </select>
        }
      } @else if (statesOptions.length) {
        <select
          class="form-select"
          id="state-{{ countryCode }}"
          formControlName="state"
          [class.is-invalid]="formGroup.get('state')?.invalid && formGroup.get('state')?.touched">
          <option value="" disabled>Selecione um estado</option>
          @for (state of statesOptions; track state.code) {
            <option [value]="stateOptionValue(state)">{{ state.name }}</option>
          }
        </select>
      } @else {
        <input
          type="text"
          id="state"
          formControlName="state"
          class="form-control"
          placeholder="Estado / departamento / região"
          [class.is-invalid]="formGroup.get('state')?.invalid && formGroup.get('state')?.touched" />
      }
      <div class="invalid-feedback">
        @if (formGroup.get("state")?.hasError("required")) {
          Informe um estado
        } @else if (formGroup.get("state")?.hasError("maxlength")) {
          O estado só pode ter no máximo 80 caracteres.
        }
      </div>
    </div>
  </div>
  @if (isLoadingCep) {
    <div id="cepHelp" class="form-text alert alert-info">Buscando dados de endereço do CEP fornecido.</div>
  }

  <div class="form-group form-group-columns">
    <div class="mb-3 flex-grow-1">
      <label for="city_name" class="form-label">Cidade</label>
      <input
        type="text"
        class="form-control"
        id="city_name"
        formControlName="city_name"
        placeholder="Digite a cidade"
        [readonly]="isLoadingCep"
        [class.loading-field]="isLoadingCep"
        [class.is-invalid]="formGroup.get('city_name')?.invalid && formGroup.get('city_name')?.touched" />
      <div class="invalid-feedback">O campo de cidade é obrigatório e aceita somente letras.</div>
    </div>

    <div class="mb-3" style="min-width: 240px">
      <label for="district" class="form-label">Bairro/Distrito</label>
      <input
        type="text"
        class="form-control"
        id="district"
        formControlName="district"
        placeholder="Digite o bairro"
        [readonly]="isLoadingCep"
        [class.loading-field]="isLoadingCep"
        [class.is-invalid]="formGroup.get('district')?.invalid && formGroup.get('district')?.touched" />
      @if (formGroup.get('district')?.invalid && formGroup.get('district')?.touched) {
        <div class="invalid-feedback">
          O campo bairro é obrigatório.
        </div>
      }
    </div>
  </div>

  <div class="mb-3">
    <label for="street" class="form-label">Rua</label>
    <input
      type="text"
      class="form-control"
      id="street"
      formControlName="street"
      placeholder="Digite o nome da rua"
      [readonly]="isLoadingCep"
      [class.loading-field]="isLoadingCep"
      [class.is-invalid]="formGroup.get('street')?.invalid && formGroup.get('street')?.touched" />
    @if (formGroup.get('street')?.invalid && formGroup.get('street')?.touched) {
      <div class="invalid-feedback">
        O campo rua é obrigatório.
      </div>
    }
  </div>

  <div class="row mb-3">
    <div class="col">
      <label for="number" class="form-label">Número</label>
      <input
        type="text"
        class="form-control"
        id="number"
        formControlName="number"
        placeholder="123"
        [class.is-invalid]="formGroup.get('number')?.invalid && formGroup.get('number')?.touched" />
      @if (formGroup.get('number')?.invalid && formGroup.get('number')?.touched) {
        <div class="invalid-feedback">
          O campo número é obrigatório.
        </div>
      }
    </div>
    <div class="col">
      <label for="additional_information" class="form-label">Complemento</label>
      <input
        type="text"
        class="form-control"
        id="additional_information"
        formControlName="additional_information"
        placeholder="Apt, casa, etc."
        [readonly]="isLoadingCep"
        [class.loading-field]="isLoadingCep" />
    </div>
  </div>

  @if (showAddressName) {
    <div class="mb-3">
      <label for="location_name" class="form-label">Nome do local</label>
      <input
        type="text"
        class="form-control"
        id="location_name"
        formControlName="location_name"
        placeholder="Ex.: Minha casa, Salão de Festas"
        [readonly]="isLoadingCep"
        [class.loading-field]="isLoadingCep"
        [class.is-invalid]="formGroup.get('location_name')?.invalid && formGroup.get('location_name')?.touched" />
      @if (formGroup.get("location_name")?.invalid && formGroup.get("location_name")?.touched) {
        <div class="invalid-feedback">O campo rua é obrigatório.</div>
      }
    </div>
  }
</div>
